import './style.css'

import image from './assets/instacarro-logo.svg'

export default function Header({children}) {
    return (
        <header className="site-header">
            <a href="/" rel="home" tabIndex={-1}>
                <img src={image} loading="lazy" decoding="async" alt="InstaCarro" height="42" width="168" />
            </a>
            {
                children &&
                <span style={{color: '#666', position: 'absolute', top: '8px', marginLeft: '-32px', fontSize: '14px'}}>
                    {children}
                </span>
            }
        </header>
    )
}
